import { IOrderItem } from '../model/IOrder';

/**
 * Every distinct vendor on an order, comma joined.
 *
 * An order can be split across suppliers, and a report row is one order, so
 * the Vendor column has to hold all of them. Items with no vendor are left
 * out rather than shown as a gap.
 */
export function getVendorListFromOrderItems(orderItems?: IOrderItem[]) {
  return Array.from(
    new Set(
      (orderItems || []).reduce(
        (acc, { vendor }) => [...acc, ...(vendor?.name ? [vendor.name] : [])],
        [] as string[],
      ),
    ),
  ).join(', ');
}
